<template lang="pug">
md-layout(md-column)
  // Page loader
  md-progress.md-accent(md-indeterminate='', v-show='loadingComponent')
  // Page content
  md-theme(md-name='blue', v-show='!loadingComponent')
    // Title
    breadcrumbs#scrollToError(section='Series', :nav='nav')

    // Form
    md-layout.form-wrapper(:md-gutter='16')
      md-whiteframe.form-wrapper-frame(md-elevation='3')
        .md-headline Images
          p.errorMessage(v-if='noImagesLive') If status is "live" the images are required
          ImageUploadCroped(:accountID='accountID', @uploadSuccessPoster='onUploadSuccess', @uploadSuccessHero='onHeroImageUploadSuccess', @uploadSuccessPortrait='onUploadPortraitSuccess', :media-item="serie", :is-series="true")
      //- md-whiteframe.form-wrapper-frame(md-elevation='3', v-if='serie.thumbnail === ""')
        .md-headline Poster Series
        image-uploader(@uploadSuccess='onUploadSuccess', @uploadFailed='onUploadFailure', label='Series Poster', :form-submitted='formSubmitted', :validations='$v', :accountID="accountID", :status='serie.status')
      //- md-whiteframe.form-wrapper-frame(md-elevation='3', v-if='serie.thumbnail != ""')
        serie-thumbnail(:url='serie.thumbnail')
        md-button.md-raised.md-primary.center(@click='deletePoster') Delete poster
      //- md-whiteframe.form-wrapper-frame(md-elevation='3')
        hero-image-uploader(label='Hero image', :accountID='accountID', @uploadSuccess='onHeroImageUploadSuccess', :form-submitted='formSubmitted', :validations='$v.serie', :url='serie.heroImage', :status='serie.status')
      md-whiteframe.form-wrapper-frame(md-elevation='3')
        serie-form(:entity='serie', :form-submitted='formSubmitted', :validations='$v.serie', title='')
        // Status
        status-radio(v-model='serie.status')
      md-whiteframe.form-wrapper-frame(md-elevation='3')
        properties-form(:entity='serie', :showMarketplaceSwitch='false', :form-submitted='formSubmitted', :validations='$v.serie')
      md-layout(md-align='center')
        stitch-loader(:loading='creatingOrUpdating', :size='40')
        md-button#submit-btn.md-raised.md-primary(@click='onFormSubmit', v-show='!creatingOrUpdating', :disabled="$v.$pending")
          | {{ editMode ? 'Update' : 'Create' }}
</template>

<script>
  import { validationMixin } from 'vuelidate';
  import { required } from 'vuelidate/lib/validators';
  import StatusRadio from '../../shared-components/StatusRadio';
  import StitchLoader from '../../shared-components/Loader';
  import serieService from '../../services/serieService';
  import SerieForm from '../../shared-components/forms/SerieForm';
  import SerieThumbnail from '../../shared-components/SerieThumbnail.vue';
  import Breadcrumbs from '../../shared-components/Breadcrumbs';
  import ImageUploader from '../../shared-components/upload/ImageUploader'
  import PropertiesForm from '../../shared-components/forms/PropertiesForm.vue';
  import HeroImageUploader from '../../shared-components/upload/HeroImageUploader.vue';
  import ImageUploadCroped from '../../shared-components/upload/ImageUploadCroped.vue';
  import { mapState } from 'vuex';

  export default {
    mixins: [validationMixin],
    data() {
      return {
        loadingComponent: false,
        creatingOrUpdating: false,
        fileUploaded: false,
        formSubmitted: false,
        noImagesLive: false,
        serie: {
          name: '',
          shortDescription: '',
          longDescription: '',
          thumbnail: '',
          isMiniSerie: false,
          tags: [],
          genres: [],
          categories: [],
          status: 'draft',
          heroImage: '',
          thumbnail2x3: '',
        }
      };
    },
    validations: {
      serie: {
        name: {
          required,
        },
        categories: {
          type: Array,
          required
        },
        tags: {
          type: Array,
          required
        },
        genres: {
          type: Array,
          required
        },
        shortDescription: {
          required
        },
        heroImage: {
          validStatus(value){
          if(this.serie.status !== 'public' && (value !== 'false' || !!value)){
            return true
          } else{
            return required(value)
          }
        },
        },
        thumbnail: {
          validStatus(value){
          if(this.serie.status !== 'public' && (value !== 'false' || !!value)){
            return true
          } else{
            return required(value)
          }
        },
        }
      }
    },
    components: {
      StatusRadio,
      StitchLoader,
      SerieForm,
      Breadcrumbs,
      ImageUploader,
      PropertiesForm,
      SerieThumbnail,
      HeroImageUploader,
      ImageUploadCroped
    },
    computed: {
      ...mapState({
        accountID: state => state.user.siteuser.user_metadata.account_id
      }),
      nav() {
        return [
          { title: 'Series', route: 'Series' },
          { title: this.editMode ? 'Edit Series' : 'New Series' }
        ]
      },
      editMode() {
        return !!this.$route.params.id;
      }
    },
    methods: {
      showAlertToast(text, icon){
        this.$swal({
              text: text,
              position: 'bottom-left',
              icon: icon,
              toast: true,
              timer: 3000,
              timerProgressBar: true,
              showConfirmButton: false,
              }
            )
      },

      createSerie() {
        this.creatingOrUpdating = true;
        serieService.create(this.serie)
          .then(() => {
            this.showAlertToast('Series created successfully', 'success');
            this.$delayedNavigation(this.$router, 'Series');
          })
          .catch(() => {
            const scrollToError = this.$el.querySelector("#scrollToError");
            scrollToError.scrollIntoView({ behavior: "smooth" });
          })
          .then(() => {
            this.creatingOrUpdating = false;
          });
      },
      updateSerie() {
        this.creatingOrUpdating = true;
        serieService.update(this.$route.params.id, { _id: this.$route.params.id, ...this.serie })
          .then(() => {
            this.showAlertToast('Series updated successfully', 'success');
            this.$delayedNavigation(this.$router, 'Series');
          })
          .catch(() => {
            this.showAlertToast('Series could not be updated. Please, try again later.', 'error');
          })
          .then(() => {
            this.creatingOrUpdating = false;
          });
      },
      checkInvalidImages(){
      return this.serie.status === "public" && (this.serie.heroImage === "false" || this.serie.heroImage === "" || this.serie.thumbnail === '' ||  this.serie.thumbnail2x3 === '' )
    },

      onFormSubmit() {
        this.noImagesLive = false;
        this.formSubmitted = true;
        setTimeout(() => {
          if (!this.$v.$invalid) {
            if (this.editMode) {
            if (this.checkInvalidImages()) {
              this.noImagesLive = true;
              const scrollToError = this.$el.querySelector("#scrollToError");
              scrollToError.scrollIntoView({ behavior: "smooth" });
            } else {
              this.noImagesLive = false;
              this.updateSerie();
            }
          } else {
            this.noImagesLive = false;
            this.createSerie();
          }
        }else{
          if(this.checkInvalidImages()) this.noImagesLive = true;
          const scrollToError = this.$el.querySelector("#scrollToError");
          scrollToError.scrollIntoView({ behavior: "smooth" })
        }
      }, 800);
      },

      deletePoster(){
        this.serie.thumbnail = '';
      },
      onHeroImageUploadSuccess({ url }) {
        this.serie.heroImage = url;
      },
      onUploadPortraitSuccess({ url }) {
        this.serie.thumbnail2x3 = url;
      },
      onUploadFailure() {
        this.showAlertToast('The image could not be uploaded. Image dimensions must be at least 800x450.', 'error');
      },

      onUploadSuccess({ url, mimeType }) {
        this.fileUploaded = true;
        this.serie.thumbnail = url
      },
    },
    mounted() {
      if (this.editMode) {
        this.loadingComponent = true;
        serieService.get(this.$route.params.id)
          .then((response) => {
            this.serie = response.data.serie;
          })
          .catch(() => {
            this.showAlertToast('Series data could not be retrieved. Please, try again later.', 'error');
          })
          .then(() => {
            this.loadingComponent = false;
          });
      }
    }
  };
</script>

<style lang="scss" scoped>
.errorMessage{
  color: #ff5722;
  font-size: 16px;
}
  .form-wrapper {
    width: 100%;
    padding: 25px 20%;
    .form-wrapper-frame {
      width: 100%;
      padding: 25px;
      margin-bottom: 15px;
      .md-subheading {
        margin-top: 35px;
      }
    }
    @media (max-width: 1200px) {
      padding: 10px .5%;
      margin-left: 0;
    }
  }
  .title-icon {
    margin-top: -5px;
  }
  #submit-btn {
    margin: 25px 0;
    width: 33%;
    padding: 6px;
    font-size: 1.1em;
  }
  .alert-msg {
    margin-left: 5px;
  }
  .center{
    margin: 0 auto;
    position: relative;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/spa/serie/SerieForm.vue